import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { ProjectStatus } from '../../../app/components/project/common/project.interfaces';

@Component({
	selector: 'mos-status-badge',
	templateUrl: './status-badge.component.html',
	imports: [NgClass, ],
	standalone: true,
}) export class StatusBadgeComponent {
	@Input() public label: string;
	@Input() public capitalize?: boolean = false;
	@Input() public status: ProjectStatus;
}